import { Section } from '@/components/layout';
import { BunnyVideo } from '@/components/media';
import { Reveal } from '@/components/motion';
import { GoldLine } from '@/components/ornaments';
import { DisplayTitle } from '@/components/typography';
import styles from './HubTestimonios.module.css';

/**
 * Vídeo genérico de testimonios que mandó el cliente el 2-nov-2026: asistentes
 * reales hablando a cámara, así que no choca con la línea roja de ADR-003.
 *
 * Va detrás del manifiesto y no junto a «Otros ya han estado antes»: ahí quedaba
 * a 3.800 px en escritorio y 7.150 en móvil, y el cliente ya dejó de encontrar
 * vídeos colocados así de abajo (ver `VslInline.tsx`).
 */
export function HubTestimonios() {
  return (
    <Section background="alt" labelledBy="hub-testimonios-title" width="default">
      <div className={styles.bloque}>
        <Reveal>
          <DisplayTitle id="hub-testimonios-title" level={2} size="md" align="center">
            Testimonios
          </DisplayTitle>
        </Reveal>

        <Reveal delay={0.06}>
          <GoldLine ornament="diamond" width="sm" />
        </Reveal>

        <Reveal delay={0.12} className={styles.celda}>
          <div className={styles.marco}>
            <BunnyVideo
              videoId="8251c246-7d2c-445c-8e77-9f01fd8a7892"
              description="Testimonios de personas que han asistido a los encuentros de Azrahel del Mayor"
              className={styles.video}
            />
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
